import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { getAnalyzeLoading: true, data: '', error: false };

export function getAnalyzeData(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_ANALYZE_DATA:
            return {
                getAnalyzeLoading: true,
                data: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_ANALYZE_DATA:
            return {
                getAnalyzeLoading: false,
                data: action.res,
                error: false
            };
        case AnalyzeConstants.ANALYZE_DATA_ERROR:
            return {
                getAnalyzeLoading: false,
                data: '',
                error: action.error.response.data
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/getAnalyzeData.reducer.js